module.exports = __webpack_public_path__ + "static/media/bgImage.cc4da290.jpg";